import React, { useState } from 'react'

function IconFb({ width = 20, height = 20, styles = { bgColor: '#C0C0C0' }}) {
    const [hover, setHover] = useState(false)

    return (
        <svg
            width={width}
            height={height}
            viewBox='0 0 20 20'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
        >
            <g clipPath='url(#clip0_198_565)'>
                <path
                    d='M19.1667 10.0021C19.1667 4.94212 15.06 0.835449 10 0.835449C4.94001 0.835449 0.833344 4.94212 0.833344 10.0021C0.833344 14.4388 3.98668 18.1329 8.16668 18.9855V12.7521H6.33334V10.0021H8.16668V7.71045C8.16668 5.94128 9.60584 4.50212 11.375 4.50212H13.6667V7.25212H11.8333C11.3292 7.25212 10.9167 7.66462 10.9167 8.16878V10.0021H13.6667V12.7521H10.9167V19.123C15.5458 18.6646 19.1667 14.7596 19.1667 10.0021Z'
                    fill={hover ? '#1877F2' : styles.bgColor}
                    style={{
                        opacity: hover ? 0 : 1,
                        transition: 'opacity .3s ease'
                    }}
                />
                <path
                    d='M19.1667 10.0021C19.1667 4.94212 15.06 0.835449 10 0.835449C4.94001 0.835449 0.833344 4.94212 0.833344 10.0021C0.833344 14.4388 3.98668 18.1329 8.16668 18.9855V12.7521H6.33334V10.0021H8.16668V7.71045C8.16668 5.94128 9.60584 4.50212 11.375 4.50212H13.6667V7.25212H11.8333C11.3292 7.25212 10.9167 7.66462 10.9167 8.16878V10.0021H13.6667V12.7521H10.9167V19.123C15.5458 18.6646 19.1667 14.7596 19.1667 10.0021Z'
                    fill={hover ? '#1877F2' : styles.bgColor}
                    style={{
                        opacity: hover ? 1 : 0,
                        transition: 'opacity .3s ease'
                    }}
                />
            </g>
            <defs>
                <clipPath id='clip0_198_565'>
                    <rect width='20' height='20' fill='white' />
                </clipPath>
            </defs>
        </svg>
    )
}

export default IconFb
